import type { Prototype } from "../prototype-types";

export const sophiaArriolaGibsonPrototypes: Prototype[] = [
  {
    id: "faire-forecast-hub",
    name: "Faire Forecast Hub",
    path: "/sag/faire-forecast-hub",
    description:
      "Interactive analytics hub with editorial content for retailers.",
    owner: "Sophia Arriola-Gibson",
    createdAt: "2026-03-12",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/febcbc3b40532a7494125f5fa2f5708d6034148b91f79c6b9ba6b1b8863c657d.png",
    creationTool: "cursor",
  },
  {
    id: "brand-order-detail-animated-illustration",
    name: "Brand Order Detail Animated Illustration",
    path: "/sag/brand-order-detail-animated-illustration",
    description:
      "Animated illustration exploration for brand order details page.",
    owner: "Sophia",
    createdAt: "2026-01-30",
    lastUpdated: "2026-01-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4954e81326a193869af4860fb18465792f9c83823c7912cf0887e24aed8e9d4e.png",
    creationTool: "cursor",
  },
];
